import {FilterItemType} from '../enum/FilterItemType'
import {IFilterItem} from '../types/IFilterItem'
import {IFilterPropertyItem} from '../types/IFilterPropertyItem'
import {IFilterValueTypeItem} from '../types/IFilterValueTypeItem'
import {PropertyValueType} from '../../DatabasePropertyService/types/PropertyValueType'
import {isFilterGroupItem} from './isFilterGroupItem'

export interface IFilterReferences {
  propertyIds: Set<string>
  valueTypes: Set<PropertyValueType>
}

// The columns a filter reads: property items name one column, value-type items every column of that type
export function getFilterReferences(filter: IFilterItem | null | undefined): IFilterReferences {
  const references: IFilterReferences = {
    propertyIds: new Set(),
    valueTypes: new Set(),
  }
  const visit = (item: IFilterItem | null | undefined) => {
    if(!item) {
      return
    }
    if(isFilterGroupItem(item)) {
      item.items?.forEach(visit)
      return
    }
    if(item.type === FilterItemType.Property) {
      references.propertyIds.add((item as IFilterPropertyItem).id)
    } else if(item.type === FilterItemType.ValueType) {
      references.valueTypes.add((item as IFilterValueTypeItem).valueType)
    }
  }
  visit(filter)
  return references
}
